module.exports = __webpack_public_path__ + "img/vibeify.3cfc40cc.gif";